export function authPlaybackSessionChanged(
  previousSessionKey: string | null,
  nextSessionKey: string | null
): boolean {
  return previousSessionKey !== nextSessionKey;
}
